import React from "react";
import classnames from "classnames";
import cssClass from "./Grid.module.scss";

const Grid = ({
  children,
  className,
  columns,
  itemsArray,
  verticallyCenterItems,
  horizontallyCenterItems,
  articleLayout,
}) => {
  const classes = classnames(cssClass.gridContainer, className, {
    [cssClass.twoColumns]: columns === 2,
    [cssClass.threeColumns]: columns === 3,
    [cssClass.fourColumns]: columns === 4,
    [cssClass.fiveColumns]: columns === 5,
    [cssClass.verticallyCenterItems]: verticallyCenterItems,
    [cssClass.horizontallyCenterItems]: horizontallyCenterItems,
    [cssClass.articleLayout]: articleLayout,
    [cssClass.flexOverride]: itemsArray && itemsArray.length < columns,
  });

  return <div className={classes}>{children}</div>;
};

export default Grid;
